import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Paper,
    FormControl,
    TextField,
    InputLabel,
    Button,
    MenuItem,
    Select,
    Link,
} from "@mui/material";
import { paperStyles, loginStyles, linkStyles } from './styles.js';
import { BUTTONS, MESSAGES } from '../../shared/constants';
import { validateUser,
         getAirportsByPermission,
         getAllPermissions
} from './logic.js';
import AlertDialog from '../alert-dialog';

const Login = () => {
  const [login, setLogin] = useState(null);
  const [password, setPassword] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [isRecovering, setIsRecovering] = useState(false);


  const handleClickOpen = () => {
    setLoading(false);
    setOpen(true);
  };

  const handleKeyDown = async (e, field) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Previene la acción por defecto del enter
      switch(field) {
        case 'login':
          document.getElementById('password-input').focus();
          break;
        case 'password':
          setLoading(true);
          await validateUser(login, password, false, setMessage, setOpen, handleCompanies);
          setLoading(false);
          break;
        default:
          break;
      }
    }
  };

  const handleKeyDownRecover = async (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (!loading && login) {
        setLoading(true);
        await validateUser(login, '', true, setMessage, setOpen, handleCompanies);
        setLoading(false);
      }
    }
  };


  const handleClose = () => {
    setLoading(false);
    setOpen(false);
  };

  const handleCompanies = (companyList) => {
    setCompanies(companyList);
  };

  const handleLogin = async () => {
    setLoading(true);
    await validateUser(login, password, false, setMessage, setOpen, handleCompanies);
    setLoading(false);
  };

  const confirmCompanySelection = async () => {
    setLoading(true);

    if (selectedCompany) {
      const user = JSON.parse(sessionStorage.getItem("data-user")) || {};

      //Airports
      user.countryCode = selectedCompany;
      var companyId = user.countryCode.split('-')[0];
      var employeeId = user.employeeId;
      var airports = await getAirportsByPermission(employeeId, companyId); 
      user.airports = airports;

      //Permissions
      var permissions = await getAllPermissions(user.employeeId ,companyId);
      user.employeePosition.employeePositionOptions = permissions;

      user.company = selectedCompany;

      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.removeItem("data-user");
     
      window.location = "/";
    }

    setLoading(false);
  };

  return (
    <>
      {open && <AlertDialog
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        dialogContentText={message}
        dialogTitle={MESSAGES.ALERT}
        open={open}
      />}
      <Paper elevation={10} style={{ ...paperStyles, padding: '20px', textAlign: 'center', width: '300px' }}>
        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src="./logo.png" alt="logo" style={{ ...loginStyles, marginBottom: '20px' }} />

          {companies.length === 0 && !isRecovering ? (
            <>
              <TextField
                label="Usuario"
                placeholder="Usuario"
                value={login}
                onChange={e => setLogin(e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, 'login')}
                fullWidth
                style={{ marginBottom: '15px' }}
              />
              <TextField
                id='password-input'
                label="Clave"
                placeholder="Clave"
                value={password}
                type='password'
                onChange={e => setPassword(e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, 'password')}
                fullWidth
                style={{ marginBottom: '20px' }}
              />
              <LoadingButton
                fullWidth
                loading={loading}
                color="primary"
                variant="contained"
                onClick={handleLogin}
                style={{ padding: '10px', fontSize: '16px' }}
              >
                {BUTTONS.LOGIN}
              </LoadingButton>
              <Link
                style={{ ...linkStyles, marginTop: '15px' }}
                component="button"
                variant="body2"
               onClick={() => {
                  setLogin("");
                  setPassword("");
                  setIsRecovering(true);
                }}
              >
                ¿Olvidó su Clave?
              </Link>
            </>
            ) : companies.length === 0 && isRecovering ? (
              <>
                <TextField
                  label="Usuario"
                  placeholder="Usuario"
                  value={login}
                  onChange={e => setLogin(e.target.value)}
                  onKeyDown={handleKeyDownRecover}
                  fullWidth
                  style={{ marginBottom: '20px' }}
                />
                <LoadingButton
                  fullWidth
                  loading={loading}
                  color="primary"
                  variant="contained"
                  disabled={loading || !login}
                  onClick={async () => {
                              setLoading(true);
                              await validateUser(login, '', true, setMessage, setOpen, handleCompanies);
                              setLoading(false);
                            }}
                  style={{ padding: '10px', fontSize: '16px' }}
                >
                  Recuperar Clave
                </LoadingButton>
                <Link
                  style={{ ...linkStyles, marginTop: '15px' }}
                  component="button"
                  variant="body2"
                  onClick={() => {
                    setLogin("");
                    setPassword("");
                    setIsRecovering(false);
                  }}
                >
                  Volver al inicio de sesión
                </Link>
              </>
          ) : (
            <>
             <FormControl 
              fullWidth 
              variant="outlined" 
              style={{ 
                marginBottom: '20px', 
                textAlign: 'center', 
                display: 'flex', 
                alignItems: 'center', 
                flexDirection: 'column'
              }}
            >
              <InputLabel 
                id="company-select-label" 
                shrink={true} 
                style={{ 
                  fontSize: '18px', 
                  fontWeight: 'bold', 
                  color: '#1976D2', 
                  textAlign: 'center',
                  marginBottom: '15px',
                  marginLeft: '30px'
                }}
              >
                Seleccione su Compañía
              </InputLabel>
              <Select
                labelId="company-select-label"
                value={selectedCompany}
                onChange={(e) => setSelectedCompany(e.target.value)}
                fullWidth
                style={{ 
                  width: '80%', 
                  marginTop: '20px', 
                  borderRadius: '8px', 
                  backgroundColor: '#F9FAFB', 
                }}
              >
                {companies.map(company => (
                  <MenuItem key={company.id} value={`${company.id}-${company.shortName}`}>
                    {company.shortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <LoadingButton
              fullWidth
              loading={loading}
              color="primary"
              variant="contained"
              onClick={confirmCompanySelection}
              disabled={!selectedCompany || loading}
              style={{
                padding: '10px',
                fontSize: '16px',
                backgroundColor: selectedCompany && !loading ? '#1976D2' : '#B0BEC5',
                color: 'white',
                fontWeight: 'bold',
                transition: '0.3s',
                minHeight: '40px',
              }}
            >
              <span style={{ visibility: loading ? 'hidden' : 'visible' }}>
                Confirmar
              </span>
            </LoadingButton>
            </>
          )}
        </FormControl>
      </Paper>
    </>
  );
};

export default Login;
